// extracted by mini-css-extract-plugin
export var productImage = "_ql-1";
export var viewLink = "_ql-2";
export var wishlistItem = "_ql-0";